import { render } from "./CatalogueList.vue?vue&type=template&id=a3d2b23a&scoped=true"
import script from "./CatalogueList.vue?vue&type=script&lang=js"
export * from "./CatalogueList.vue?vue&type=script&lang=js"

import "./CatalogueList.vue?vue&type=style&index=0&id=a3d2b23a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d2b23a"]])

export default __exports__